import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps, TranslationOptionsParams } from 'src/shared/shared.types';

export type S01FindADoctorProps = RenderingProps<S01FindADoctorFields, S01FindADoctorParams>;

export type S01FindADoctorFields = {
  FilterType?: Field<string>;
};

export type S01FindADoctorParams = TranslationOptionsParams;
